<div class="container-fluid">
  <div class="card analytics-card">
    <div class="card-body">
      <div class="header">
        <div class="header-left">
          <div class="title">Monthly Segment Analytics</div>

          <div class="view-breadcrumb" *ngIf="currentView === 'subsegment'">
            <span>Selected Segment:</span>
            <strong>{{ selectedSegment }}</strong>
          </div>
        </div>

        <div class="filters">
          <div class="filter-item">
            <label for="beginDate">Begin Date</label>
            <input id="beginDate"
                   type="date"
                   [(ngModel)]="beginDate" />
          </div>

          <div class="filter-item">
            <label for="endDate">End Date</label>
            <input id="endDate"
                   type="date"
                   [(ngModel)]="endDate" />
          </div>

          <div class="filter-item">
            <label for="statusSelect">Status</label>
            <select id="statusSelect"
                    [(ngModel)]="selectedStatus">
              <option [ngValue]="0">All Statuses</option>
              <option *ngFor="let s of statusObj" [ngValue]="s.id">{{ s.name }}</option>
            </select>
          </div>

          <div class="filter-actions">
            <button type="button"
                    class="btn btn-search"
                    (click)="onSearch()">
              Search
            </button>
          </div>
        </div>
      </div>

      <div class="kpi-row">
        <div class="kpi-box">
          <div class="kpi-label">Spend Evaluation</div>
          <div class="kpi-value" [ngClass]="priceChangeClass">{{ priceChangeText }}</div>
          <div class="kpi-subtext">{{ priceChangeSubtext }}</div>
        </div>

        <div class="kpi-box">
          <div class="kpi-label">Order Evaluation</div>
          <div class="kpi-value" [ngClass]="orderChangeClass">{{ orderChangeText }}</div>
          <div class="kpi-subtext">{{ orderChangeSubtext }}</div>
        </div>
      </div>

      <div class="chart-toolbar" *ngIf="!isLoading">
        <div class="chart-toolbar-left">
          <button *ngIf="currentView === 'subsegment'"
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  (click)="backToSegments()">
            All Segments
          </button>

          <div class="toolbar-info" *ngIf="currentView === 'segment'">
            Click any segment bar to view subsegments
          </div>

          <div class="toolbar-info" *ngIf="currentView === 'subsegment'">
            Showing subsegments for <strong>{{ selectedSegment }}</strong>
          </div>
        </div>
      </div>

      <div class="charts-row" *ngIf="!isLoading">
        <div class="chart-box">
          <div class="chart-title">
            {{ currentView === 'segment' ? 'Usage Amount by Segment' : 'Usage Amount by Subsegment' }}
          </div>
          <div class="chart-wrap">
            <canvas id="priceChart"></canvas>
          </div>
        </div>

        <div class="chart-box">
          <div class="chart-title">
            {{ currentView === 'segment' ? 'Order Count by Segment' : 'Order Count by Subsegment' }}
          </div>
          <div class="chart-wrap">
            <canvas id="orderChart"></canvas>
          </div>
        </div>
      </div>

      <div class="loading-box" *ngIf="isLoading">
        Loading chart data...
      </div>

      <div class="table-section" *ngIf="!isLoading">
        <div class="table-header">
          <div class="table-title">
            {{ currentView === 'segment' ? 'Segment Summary Table' : 'Subsegment Summary Table' }}
          </div>
        </div>

        <div class="table-toolbar">
          <div class="table-summary">
            <span>Total Price: <strong>{{ getTotalPrice() | number:'1.2-2' }}</strong></span>
            <span>Total Orders: <strong>{{ getTotalOrders() }}</strong></span>
            <span>Total Records: <strong>{{ getTotalRowCount() }}</strong></span>
          </div>

          <div class="table-toolbar-right">
            <button type="button"
                    class="btn btn-success btn-sm"
                    (click)="exportTableToExcel()">
              Export Excel
            </button>
          </div>
        </div>

        <div class="table-wrap">
          <table class="table analytics-table table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ currentView === 'segment' ? 'Segment' : 'Subsegment' }}</th>
                <th class="text-right">Price</th>
                <th class="text-right">Order Count</th>
                <th class="text-right">Record Count</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of summaryTableData; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.name }}</td>
                <td class="text-right">{{ item.price | number:'1.2-2' }}</td>
                <td class="text-right">{{ item.orderCount }}</td>
                <td class="text-right">{{ item.rowCount }}</td>
              </tr>

              <tr *ngIf="summaryTableData.length === 0">
                <td colspan="5" class="empty-row">No data found.</td>
              </tr>
            </tbody>

            <tfoot *ngIf="summaryTableData.length > 0">
              <tr>
                <th colspan="2" class="text-right">Total</th>
                <th class="text-right">{{ getTotalPrice() | number:'1.2-2' }}</th>
                <th class="text-right">{{ getTotalOrders() }}</th>
                <th class="text-right">{{ getTotalRowCount() }}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
